import React from 'react';
import PropTypes from 'prop-types';
import { Button, Link as MuiLink } from '@mui/material';

import { status } from 'venuescanner-js/constants/thread';
import CtaShowToOrganiser from 'venuescanner-js/react/components/Inbox/components/Objects/Ctas/CtaShowToOrganiser';
import Tip from 'venuescanner-js/react/components/Inbox/components/Objects/Tip';
import EnquiryCtas from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryCtas/index.js';

const HostBookedCTAs = ({ thread, send, venue, enquiryStatus }) => {
  // On the abstract, we are dealing with two users communicating
  // Events of one might cause different actions on the other.
  //
  // The challenge here is we're representing a two way communication
  // with a single machine and the same components,
  // which starts to get convoluted and with multiple conditionals.
  //
  // I think we need to map out the two way communication, events emitted
  // from both users and transitions/states for each independently.
  //
  // After that, we build two machines and separate the components by user type.
  if (enquiryStatus === status.BOOKED_BY_ORG) {
    return (
      <EnquiryCtas sx={{ mt: 'auto', pt: 0 }}>
        <Button
          fullWidth
          color='primary'
          variant='contained'
          size='medium-large'
          onClick={() => send({ type: 'CONFIRM_BOOKING' })}>
          Confirm
        </Button>
        <Button
          fullWidth
          color='primary'
          variant='outlined'
          size='medium-large'
          onClick={() => send({ type: 'NOT_A_BOOKING' })}>
          Not a booking
        </Button>
        <Tip
          title='Marked as booked'
          text='The organiser has told us they booked your venue. Please confirm the booking details.'
        />
        {thread.hide_from_organiser ? (
          <CtaShowToOrganiser thread={thread} />
        ) : null}
      </EnquiryCtas>
    );
  }

  const isVenueSubscribed = !!venue.sub_plan;

  return (
    <EnquiryCtas sx={{ mt: 'auto' }}>
      {thread.hide_from_organiser && <CtaShowToOrganiser thread={thread} />}
      {!isVenueSubscribed && <SubscriptionStatusMessageContainer />}
    </EnquiryCtas>
  );
};

HostBookedCTAs.propTypes = {
  thread: PropTypes.object.isRequired,
  send: PropTypes.func.isRequired,
  venue: PropTypes.object.isRequired,
  enquiryStatus: PropTypes.string,
};

const SubscriptionStatusMessageContainer = () => {
  const revenueWebflowLink =
    'https://www.venuescanner.com/pages/landing/case-study/commission-free';

  return (
    <Tip
      title='Tip'
      text={
        <>
          Don’t want to pay commission on bookings? Keep all your revenue
          with&nbsp;
          <MuiLink
            sx={{
              fontWeight: 600,
              color: 'inherit',
              textDecoration: 'underline',
            }}
            href={revenueWebflowLink}
            target='blank'>
            VenueScanner membership
          </MuiLink>
        </>
      }
    />
  );
};

export default HostBookedCTAs;
